import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import * as Constant from 'src/app/utils/constant/paths'
import { constant } from 'lodash';

import { CapacitorHttp } from '@capacitor/core';


@Injectable({
  providedIn: 'root'
})
export class GetUserpoolService {
  public name;

  setData(data:any){
    this.name = data;
  }

  getData(){
    return this.name
  }

  constructor(
    private http: HttpService,
  ) { }


  getUserpool(req,params){
    return this.http.pool_post(Constant.Path.LOGIN.GET_USERPOOL + "?" + params.toString(),req)
  }

  getUserpool2(req,params){
    return this.http.pool_post(Constant.Path.LOGIN.GET_USERPOOL2 + "?" + params.toString(),req)
  }


  upsertPasswordExpiry(){
    return this.http.put(Constant.Path.LOGIN.UPSERT_PASSWORD_EXPIRY)
  }
  
  upsertTransaction(){
    return this.http.put(Constant.Path.LOGIN.UPSERT_TRANSACTION)
  }

  upsertUserTransaction(dateColumn: string) {
  const url = Constant.Path.USER_TRANSACTION.UPDATE_DATE_TRANSACTION.replace('{date_column_to_upsert}', dateColumn);
  return this.http.put(url);
}


  getLandingPageStatus(){
    return this.http.get(Constant.Path.LOGIN.GET_LANDING_PAGE_STATUS)
  }

  updateLandingPageStatus(req){
    return this.http.put(Constant.Path.LOGIN.UPDATE_LANDING_PAGE_STATUS, req)
  }

  getAppUser(){
    return this.http.get(Constant.Path.LOGIN.GET_APP_USER)
  }

  getPasswordExpiry() {
    return this.http.get(Constant.Path.LOGIN.GET_PASSWORD_EXPIRY)
  }


}
